export class Flags {
    public static flags = {
        'Sweden': 'assets/image/flags/Flag_of_Sweden.svg',
        'Argentina': 'assets/image/flags/Flag_of_Argentina.svg',
        'Australia': 'assets/image/flags/Flag_of_Australia.svg',
        'Austria': 'assets/image/flags/Flag_of_Austria.svg',
        'Belgium': 'assets/image/flags/Flag_of_Belgium.svg',
        'Bulgaria': 'assets/image/flags/Flag_of_Bulgaria.svg',
        'Canada': 'assets/image/flags/Flag_of_Canada_(Pantone) (1).svg',
        'Croatia': 'assets/image/flags/Flag_of_Croatia.svg',
        'Greece': 'assets/image/flags/Flag_of_Greece.svg',
        'Hungary': 'assets/image/flags/Flag_of_Hungary.svg',
        'Israel': 'assets/image/flags/Flag_of_Israel.svg',
        'Latvia': 'assets/image/flags/Flag_of_Latvia.svg',
        'Liechtenstein': 'assets/image/flags/Flag_of_Liechtenstein.svg',
        'Luxembourg': 'assets/image/flags/Flag_of_Luxembourg.svg',
        'New Zealand': 'assets/image/flags/Flag_of_New_Zealand.svg',
        'Poland': 'assets/image/flags/Flag_of_Poland.svg',
        'Portugal': 'assets/image/flags/Flag_of_Portugal.svg',
        'Serbia': 'assets/image/flags/Flag_of_Serbia.svg',
        'Slovakia': 'assets/image/flags/Flag_of_Slovakia.svg',
        'Slovenia': 'assets/image/flags/Flag_of_Slovenia.svg',
        'Spain': 'assets/image/flags/Flag_of_Spain.svg',
        'Czech Republic': 'assets/image/flags/Flag_of_Czech_Republic.svg',
        'Netherlands': 'assets/image/flags/Flag_of_the_Netherlands.svg',
        'Ukraine': 'assets/image/flags/Flag_of_Ukraine.svg',
        'Denmark': 'assets/image/flags/Flag_of_Denmark.svg',
        'Finland': 'assets/image/flags/Flag_of_Finland.svg',
        'France': 'assets/image/flags/Flag_of_France.svg',
        'Germany': 'assets/image/flags/Flag_of_Germany.svg',
        'Italy': 'assets/image/flags/Flag_of_Italy.svg',
        'Norway': 'assets/image/flags/Flag_of_Norway.svg',
        'Paraguay': 'assets/image/flags/Flag_of_Paraguay.svg',
        'Switzerland': 'assets/image/flags/Flag_of_Switzerland.svg',
        'UK': 'assets/image/flags/Flag_of_the_United_Kingdom.svg',
        'US': 'assets/image/flags/Flag_of_the_United_States.svg',
    }
}